<div class="accordions-container row">
    <div class="accordion-container col-md-12 col-lg-12 col-xxxl-12">

        <nb-card>
            <nb-card-header>FAQ</nb-card-header>
            <!-- <nb-card-body>
              <button nbButton (click)="toggle()">Toggle First Item</button>
            </nb-card-body> -->
          </nb-card>

        <nb-accordion multi>
            <nb-accordion-item expanded=true>
                <nb-accordion-item-header>
                    Do I still need to register on this portal if I have only few B2B tickets?
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                    All B2B invoices will be available on the portal
                </nb-accordion-item-body>
            </nb-accordion-item>

            <nb-accordion-item expanded=true>
                <nb-accordion-item-header>
                    What type of details/documents are required to register on the portal?
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                    A copy of the business PAN and GSTIN
                </nb-accordion-item-body>
            </nb-accordion-item>

            <nb-accordion-item expanded=true>
                <nb-accordion-item-header>
                    Can one corporate have multiple registration on this portal?
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                    No. One registration per PAN will be permitted. You may create multiple users per corporate and assign access to all or selected states
                </nb-accordion-item-body>
            </nb-accordion-item>

            <nb-accordion-item expanded=true>
                <nb-accordion-item-header>
                    Can a corporate/B2B customer allow his travel agent to download his B2B GST invoices?
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                    No
                </nb-accordion-item-body>
            </nb-accordion-item>

            <nb-accordion-item expanded=true>
                <nb-accordion-item-header>
                    What if I could not find my B2B GST invoice?
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                    We have a raise request section on the portal. You may submit the details of your purchase, and we will address the same
                </nb-accordion-item-body>
            </nb-accordion-item>

            <nb-accordion-item expanded=true>
                <nb-accordion-item-header>
                    If I find incorrect details on the GST invoice?
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                    We have a raise request section on the portal. You may submit the discrepancy details, and we will address the same
                </nb-accordion-item-body>
            </nb-accordion-item>

            <nb-accordion-item expanded=true>
                <nb-accordion-item-header>
                    How can I raise a query?
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                    Login to the portal and Click on the Raise request link on the left panel. Submit your query as for the provided form
                </nb-accordion-item-body>
            </nb-accordion-item>

            <nb-accordion-item expanded=true>
                <nb-accordion-item-header>
                    Can I download my invoice without a ticket number?
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                    Yes. You can download the invoices by just providing a date period. If you require the invoice for a particular ticket number, you can fill up the same.
                </nb-accordion-item-body>
            </nb-accordion-item>
        </nb-accordion>
    </div>
</div>
